import React, { useMemo } from 'react';
import { func, string, bool } from 'prop-types';
import styles from './styles/styles.module.scss';
import GiftCard from '../GiftCard';

const GiftCardRadioButtons = ({ onChange, selectedVariant, languageRegionCode, valentinesDayVariant }) => {
  const variants = useMemo(() => {
    const shortRegionCode = languageRegionCode.split('-')[0];

    return valentinesDayVariant
      ? [`gc-1`, `gc-2-${shortRegionCode}`, `v-day-${shortRegionCode}`]
      : [`gc-1`, `gc-2-${shortRegionCode}`, `gc-3-${shortRegionCode}`];
  }, []);

  return (
    <div className={styles.container}>
      {variants.map(variant => {
        return (
          <div key={variant} className={styles.cardRadioContainer}>
            <input
              value={variant}
              onChange={onChange}
              name="backgroundId"
              className={styles.radioButton}
              id={variant}
              type="radio"
              checked={selectedVariant === variant}
            />
            <label htmlFor={variant} className={styles.label}>
              <GiftCard backgroundId={variant} classes={styles.small} />
            </label>
          </div>
        );
      })}
    </div>
  );
};

GiftCardRadioButtons.propTypes = {
  onChange: func,
  selectedVariant: string,
  languageRegionCode: string,
  valentinesDayVariant: bool
};

GiftCardRadioButtons.defaultProps = {
  onChange: () => {},
  selectedVariant: '',
  languageRegionCode: 'en-US',
  valentinesDayVariant: false
};

export default GiftCardRadioButtons;
